import React from "react"
import { useForm, SubmitHandler } from "react-hook-form"
import { TextField, Stack, Typography, Button } from "@mui/material"
import { useUpdateInterviewerMutation } from "../../../api/InterviewsApi"
import { IInterviewer } from "../../../model/create/CreateInterwiewer"
import { useSelector } from "react-redux/es/hooks/useSelector"
import { RootState } from "../../../../../app/store"

interface FieldConfig {
  label: string
  name: keyof IInterviewer
  placeholder: string
  validation: { required: string }
}

const fields: FieldConfig[] = [
  {
    label: "ФИО собеседующего",
    name: "interviewer",
    placeholder: "Иванов Иван Иванович",
    validation: { required: "Это поле обязательно для заполнения" },
  },
  {
    label: "Постоянная ссылка на индивидуальную встречу",
    name: "permanentLink",
    placeholder: "Постоянная ссылка",
    validation: { required: "Это поле обязательно для заполнения" },
  },
  {
    label: "Постоянная ссылка на групповую встречу",
    name: "temporaryLink",
    placeholder: "Постоянная ссылка",
    validation: { required: "Это поле обязательно для заполнения" },
  },
  {
    label: "Тэг в телеграм",
    name: "tgLink",
    placeholder: "https://t.me/",
    validation: { required: "Это поле обязательно для заполнения" },
  },
]

const CreateInterwiewer = ({ open, setOpen }: any) => {
  const Interviewers = useSelector((state: RootState) => state.Interviewers)

  const {
    handleSubmit,
    formState: { errors },

    register,
    reset,
  } = useForm<IInterviewer>({
    defaultValues: {
      id: Interviewers.id,
      interviewer: Interviewers.interviewer,
      permanentLink: Interviewers.permanentLink,
      temporaryLink: Interviewers.temporaryLink,
      tgLink: Interviewers.tgLink,
    },
  })

  const [updateInterviewer] = useUpdateInterviewerMutation()

  const onSubmit: SubmitHandler<IInterviewer> = async (data) => {
    try {
      const response = await updateInterviewer(data)
      reset()
      setOpen({ ...open, openInterviewer: false })
      console.log(response)
    } catch (error) {
      reset()
      setOpen({ ...open, openInterviewer: false })
      console.error("Error Updating interview:", error)
    }
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Stack direction="column" spacing={"30px"}>
        <Stack spacing={"5px"}>
          <Typography sx={{ fontSize: 20 }}>
            {Interviewers.interviewer}
          </Typography>
          <Typography sx={{ fontSize: 14, color: "text.secondary" }}>
            ID: {Interviewers.id}
          </Typography>
        </Stack>
        <Stack direction="column" spacing={"20px"}>
          {fields.slice(1, 4).map((field) => (
            <React.Fragment key={field.name}>
              <Stack>
                <Typography sx={{ fontWeight: "bold", fontSize: 14 }}>
                  {field.label}
                </Typography>

                <TextField
                  sx={{ width: "483px" }}
                  size="small"
                  inputProps={register(field.name, field.validation)}
                  helperText={errors?.[field.name]?.message}
                  error={!!errors?.[field.name]}
                  fullWidth
                  placeholder={field.placeholder}
                />
              </Stack>
            </React.Fragment>
          ))}
        </Stack>
        <Stack direction="row" spacing={"10px"}>
          <Button
            size="large"
            sx={{ fontWeight: "bold" }}
            fullWidth
            variant="outlined"
            onClick={() => setOpen({ ...open, openInterviewer: false })}
          >
            Отмена
          </Button>
          <Button
            size="large"
            sx={{ fontWeight: "bold" }}
            fullWidth
            variant="contained"
            type="submit"
          >
            Сохранить
          </Button>
        </Stack>
      </Stack>
    </form>
  )
}

export default CreateInterwiewer
